import * as React from "react"
import { cn } from "@/lib/utils"

function Separator({ 
  className, 
  orientation = "horizontal", 
  ...props 
}: React.ComponentProps<"div"> & {
  orientation?: "horizontal" | "vertical"
}) {
  return (
    <div
      className={cn(
        "shrink-0 bg-corporate-gray-200",
        orientation === "horizontal" ? "h-[1px] w-full" : "h-full w-[1px]",
        className
      )}
      {...props}
    />
  )
}

export { Separator }
